import {Component, Inject} from '@angular/core';
import {DialogConfirmComponent} from '../dialog-confirm/dialog-confirm.component';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-two-options',
    templateUrl: './dialog-two-options.component.html',
    standalone: false
})
export class DialogTwoOptionsComponent {

  title: string = '';
  body: string = '';
  optionCancel: string = '';
  optionConfirm: string = '';

  constructor(public dialogRef: MatDialogRef<DialogConfirmComponent>,
              @Inject(MAT_DIALOG_DATA) data) {
    this.title = data.title;
    this.body = data.body;
    this.optionCancel = data.optionCancel;
    this.optionConfirm = data.optionConfirm;
  }


}
